// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xbEHE","col":"styles_col__MQDFL"};